import { NuggetBadge } from '@backrs_ui/common-ui';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { LineInfo, LineInfoIcon } from './LineInfoIcon';
import { ScoopStatBadge } from './types';

type LineBadgesItemProps = Readonly<{
  title: string;
  badges: ScoopStatBadge[];
  info?: LineInfo;
}>;

export const LineBadgesItem = ({ title, badges, info }: LineBadgesItemProps) => {
  const titleId = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <Box sx={containerSx}>
      <Box sx={titleContainerSx}>
        <Typography variant="text-md-semibold" color={({ backrs }) => backrs.colors['Brand/500']}>
          {title}
        </Typography>
        {info && <LineInfoIcon info={info} idPrefix={`line-badges-${titleId}`} />}
      </Box>

      <Box sx={badgeRowSx}>
        {badges.map((badge) => (
          <Box
            key={badge.id}
            id={badge.id}
            sx={badgeWrapperSx(!!badge.onClick)}
            onClick={badge.onClick}
          >
            <NuggetBadge label={badge.label} iconConfig={badge.iconConfig} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});

const titleContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

const badgeRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-sm'],
});

const badgeWrapperSx =
  (isClickable: boolean): SxProps<Theme> =>
  () => ({
    display: 'inline-flex',
    cursor: isClickable ? 'pointer' : 'default',
  });
